'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var svg_path = "<svg width=\"64\" height=\"64\" viewBox=\"0 0 64 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M50.2386 20H8.76139C7.23632 20 6 21.3229 6 22.9548V41.0452C6 42.6771 7.23632 44 8.76139 44H50.2386C51.7637 44 53 42.6771 53 41.0452V22.9548C53 21.3229 51.7637 20 50.2386 20Z\" fill=\"#F2E9DA\" stroke=\"#30445E\" stroke-width=\"2.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M30.0861 41V33.4026H26L30.0861 23V30.4064H34L30.0861 41Z\" fill=\"#30445E\"/>\n<rect x=\"53\" y=\"26\" width=\"5\" height=\"12\" rx=\"1\" fill=\"white\" stroke=\"#30445E\" stroke-width=\"2\"/>\n</svg>";

exports["default"] = svg_path;
